<template>
  <div class="mt-3" v-if="_contractDetail">
    <div class="bordered-group vs-card vs-con-block mt-5">
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">วันที่สัญญา</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractDate" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เลขที่สัญญา</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractNo" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ชื่อสัญญา</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractName" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">โครงการ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.projectName" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">คณะ/หลักสูตร</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.facultyCurriculumName" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">วิทยาเขต</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.campusName" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ประเภทสัญญา </label> <small class="text-grey">(Telesale, SmartApp, ปกติ,
          Online)</small>
          <vs-input type="text" class="w-full" v-model="_contractDetail.createdWithName" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">วงเงินกู้อนุมัติ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractAmount" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">วงเงินกู้อนุมัติ (ตัวอักษร)</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractAmountText" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">อัตราดอกเบี้ย <a class="cursor-pointer"
                                                          @click="onPressedActiveInterestRateDetailModal()">
            <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
          </a></label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.interestRate" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">อัตราเบี้ยปรับ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.penaltyRate" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">การคิดค่าธรรมเนียมการทวงถาม</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.debtCollectionFeeTypeName" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">สถานะสัญญา</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractStatusName" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">วันที่ปิด บช. (หากมี)</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.contractCloseDate" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ประเภทการกู้</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.loanTypeName" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row mb-0">
        <div class="vx-col w-full mb-0">
          <label class="vs-input--label">เงื่อนไขการชำระเงิน</label>
          <vs-textarea type="text" class="w-full" v-model="_contractDetail.paymentDescription" rows="3"
                       readonly="readonly"/>
        </div>
      </div>
      <vs-divider position="left"><p class="text-base">ยอดคงเหลือ ณ ปัจจุบัน</p></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ค่าธรรมเนียมคงเหลือ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.accruedFeeRemain" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ค่าเบี้ยปรับคงเหลือ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.accruedPenaltyRemain" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ดอกเบี้ยคงเหลือ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.accruedInterestRemain" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เงินต้นคงเหลือ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.principleRemain" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ดอกเบี้ยชำระล่วงหน้าคงเหลือ</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.balanceRemain" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">วันที่คำนวนดอกเบี้ยล่าสุด</label>
          <div class="flex items-center">
            <vs-input type="text" class="w-full" v-model="_contractDetail.lastUpdateDateLocalTh" readonly="readonly"/>
            <vx-tooltip text="ตำนวนดอกเบี้ยถึงวันที่ปัจจุบัน"
                        v-if="![IContractStatus.draft].includes(_contractDetail.contractStatus)">
              <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-right"
                         @click="onPressedCalculate()" class="ml-1"></vs-button>
            </vx-tooltip>
          </div>
        </div>

      </div>
      <vs-divider position="left"><p class="text-base">ค่าใช้จ่ายอื่นๆ</p></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('getters.expenseTypesOptions')[IExpenseType.contractFee]
            }}คงเหลือ</label>
          <div class="flex items-center">
            <vs-input type="text" class="w-full" v-model="_contractDetail.contractFeeRemain" readonly="readonly"/>
          </div>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{ $t('getters.expenseTypesOptions')[IExpenseType.taxAmount] }}คงเหลือ</label>
          <div class="flex items-center">
            <vs-input type="text" class="w-full" v-model="_contractDetail.taxAmountRemain" readonly="readonly"/>
          </div>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('getters.expenseTypesOptions')[IExpenseType.processingFee]
            }}คงเหลือ</label>
          <div class="flex items-center">
            <vs-input type="text" class="w-full" v-model="_contractDetail.processingFeeRemain" readonly="readonly"/>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('getters.expenseTypesOptions')[IExpenseType.courtOrderExpense]
            }}คงเหลือ</label>
          <div class="flex items-center">
            <vs-input type="text" class="w-full" v-model="_contractDetail.courtOrderExpenseRemain" readonly="readonly"/>
          </div>
        </div>
      </div>
    </div>

    <div class="bordered-group vs-card vs-con-block mt-5">
      <h6 class="mb-5">ข้อมูลผู้กู้</h6>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เลขที่บัตรประชาชน</label>
          <vs-input type="text" class="w-full" v-model="borrower.idCardNumber" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เลขที่นักศึกษา</label>
          <vs-input type="text" class="w-full" v-model="borrower.studentCode" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ชื่อ-สกุล</label>
          <vs-input type="text" class="w-full" v-model="borrower.fullName" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เบอร์มือถือ</label>
          <vs-input type="text" class="w-full" v-model="borrower.mobile" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เบอร์โทรศัพท์</label>
          <vs-input type="text" class="w-full" v-model="borrower.phone" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">อีเมลล์</label>
          <vs-input type="text" class="w-full" v-model="borrower.email" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">คณะ/หลักสูตร</label>
          <vs-input type="text" class="w-full" v-model="borrower.facultyCurriculumName" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ระดับการศึกษา</label>
          <vs-input type="text" class="w-full" v-model="borrower.degreeName" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ปีการศึกษา</label>
          <vs-input type="text" class="w-full" v-model="borrower.periodName" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <label class="vs-input--label">ที่อยู่</label>
          <vs-textarea type="text" class="w-full" v-model="borrower.fullAddress" rows="3" readonly="readonly"/>
        </div>
      </div>
    </div>

    <div class="bordered-group vs-card vs-con-block mt-5" v-if="_contractDetail.restructuring">
      <h6 class="mb-5">ข้อมูลการปรับโครงสร้างนี้</h6>

      <vs-divider position="left"><p class="text-base">ข้อมูลสัญญาเก่า</p></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">ประเภทการปรับโครงสร้างหนี้</label>
          <vs-input type="text" class="w-full" v-model="_contractDetail.restructuringTypeName" readonly="readonly"/>
        </div>

        <div class="vx-col w-1/3">
          <label class="vs-input--label">วันที่สัญญา</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.contract.contractDate" readonly="readonly"/>
        </div>

        <div class="vx-col w-1/3">
          <label class="vs-input--label">วันปิดสัญญา</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.contract.contractCloseDate"
                    readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">เลขที่สัญญา</label>
          <div class="flex items-center">
            <vs-input type="text" class="w-full" v-model="restructuringDetail.contract.contractNo" readonly="readonly"/>
            <vx-tooltip text="ดูข้อมูลสัญญา">
              <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-eye"
                         @click="onPressedGoToContract(restructuringDetail.contract.id)" class="ml-1"></vs-button>
            </vx-tooltip>
          </div>
        </div>

        <div class="vx-col w-1/3">
          <label class="vs-input--label">ชื่อสัญญา (เก่า)</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.contract.contractName" readonly="readonly"/>
        </div>
      </div>


      <vs-divider position="left"><p class="text-base">รายละเอียดการปรับโครงสร้างหนี้</p></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('sections.accounting.dataForm.restructuringDetail.restructuringDate')
            }}</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.restructuringDate" readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('sections.accounting.dataForm.restructuringDetail.accruedFeeRemain')
            }}</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.restructuringFeeRemain"
                    readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('sections.accounting.dataForm.restructuringDetail.accruedPenaltyRemain')
            }}</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.restructuringPenaltyRemain"
                    readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('sections.accounting.dataForm.restructuringDetail.accruedInterestRemain')
            }}</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.restructuringInterestRemain"
                    readonly="readonly"/>
        </div>
        <div class="vx-col w-1/3">
          <label class="vs-input--label">{{
              $t('sections.accounting.dataForm.restructuringDetail.principleRemain')
            }}</label>
          <vs-input type="text" class="w-full" v-model="restructuringDetail.principleRemain" readonly="readonly"/>
        </div>
      </div>
      <div class="vx-row mb-0">
        <div class="vx-col w-full">
          <label class="vs-input--label">หมายเหตุ</label>
          <vs-textarea type="text" class="w-full" v-model="restructuringDetail.remark" rows="5" readonly="readonly"/>
        </div>
      </div>
    </div>

    <div class="bordered-group vs-card vs-con-block mt-5">
      <div class="vs-card-content">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-table max-items="10" :data="suretyDetails">
              <template slot="header">
                <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                  <div class="vx-col w-1/2">
                    <h6>ข้อมูลผู้คำ้ประกัน</h6>
                  </div>
                  <div class="vx-col w-1/2 flex justify-end m-0 p-0">
                    <div class="flex">
                      <div class="mr-1 flex-1">
                        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"
                                   @click="onPressedActiveSuretyModal()" class="mb-1">เพิ่มข้อมูล
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th>เลขที่บัตรประชาชน</vs-th>
                <vs-th>ชื่อ-สกุล</vs-th>
                <vs-th>เบอร์มือถือ</vs-th>
                <vs-th>เกี่ยวข้องเป็น</vs-th>
                <vs-th class="col-actions"></vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                  <vs-td :data="row.seq">
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td>
                    <router-link :to="{ name: 'customer-borrower-search', params: {id: row.borrowerId}}"
                                 v-if="row.borrowerId">{{ row.idCardNumber }}
                    </router-link>
                    <template v-else>{{ row.idCardNumber }}</template>
                  </vs-td>
                  <vs-td>
                    <router-link :to="{ name: 'customer-borrower-search', params: {id: row.borrowerId}}"
                                 v-if="row.borrowerId">{{ row.fullName }}
                    </router-link>
                    <template v-else>{{ row.fullName }}</template>
                  </vs-td>
                  <vs-td :data="row.mobile">
                    {{ row.mobile }}
                  </vs-td>
                  <vs-td :data="row.relationshipName">
                    {{ row.relationshipName }}
                  </vs-td>
                  <vs-td class="ml-auto flex sm:justify-end">
                    <vx-tooltip text="ลบข้อมูล">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash"
                                 @click="onPressedDelSurety(row.id)"></vs-button>
                    </vx-tooltip>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>

    <vs-popup
      :active.sync="interestRateDetailModal.active"
      title="ข้อมูลอัตราดอกเบี้ย"
      class="custom-popup"
    >
      <div class="popup-content">
        <vs-table :data="interestRateDetails">

          <template slot="thead">
            <vs-th align="center">#</vs-th>
            <vs-th align="center">วันที่</vs-th>
            <vs-th align="center">อัตราดอกเบี้ย</vs-th>
            <vs-th align="center">อัตราเบี้ยปรับ</vs-th>
            <vs-th align="center">การคิดค่าธรรมเนียมการทวงถาม</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(row, index) in data">
              <vs-td :data="(index+1)">
                {{ (index + 1) }}
              </vs-td>
              <vs-td>
                {{ row.interestDateLocalTh }} <a class="cursor-pointer"
                                                 @click="onPressedShowInterestRateDetailRemark(row.remark)">
                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
              </a>
              </vs-td>
              <vs-td align="center">
                <div class="center-chip">
                  {{ row.interestRate | convPerYear }}<br>
                  <vs-chip color="success">{{ row.interestType | interestType }}</vs-chip>
                </div>
              </vs-td>
              <vs-td align="center">
                <div class="center-chip">
                  {{ row.penaltyRate | convPerYear }}<br>
                  <vs-chip color="success">{{ row.penaltyType | interestType }}</vs-chip>
                </div>
              </vs-td>
              <vs-td align="center">
                <div class="center-chip">
                  {{
                    row.debtCollectionFeeType === IDebtCollectionFeeType.fixed ? interestRateDefault.debtCollectionFeeAmount : '0.00'
                  }}<br>
                  <vs-chip color="primary">{{ row.debtCollectionFeeTypeName }}</vs-chip>
                </div>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="interestRateDetailModal.active = false">ตกลง</vs-button>
        <vs-button color="danger" @click="interestRateDetailModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

    <vs-popup
      :active.sync="suretyModal.active"
      title="เพิ่มข้อมูลผู้ค้ำประกัน"
      class="custom-popup"
    >
      <div class="popup-content">
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="vs-input--label">ผู้ค้ำประกัน <small class="ml-2"
                                                               v-if="totalMatched > maxOptions">
              #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalMatched }} รายการที่พบ
            </small></label>
            <div class="flex">
              <div class="mr-1 flex-1">
                <v-select
                  v-model="suretyModal.surety"
                  :filterable="false"
                  :options="filteredSureties"
                  :clearable="true"
                  @search="onSearchSurety"
                  label="label"
                >
                </v-select>
              </div>
              <div>
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-refresh-ccw"
                           @click="onPressedRefreshSuretyOptions()"></vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="vs-input--label">เกี๋ยวข้องเป็น</label>
            <div class="flex">
              <div class="mr-1 flex-1">
                <vs-select v-model="suretyModal.relationship" class="w-full ">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                                  v-for="(item,index) in relationshipOptions" class="w-full"/>
                </vs-select>
              </div>
              <div>
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-refresh-ccw"
                           @click="onPressedRefreshRelationshipOptions()"></vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddSurety">บันทึก</vs-button>
        <vs-button color="danger" @click="suretyModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

    <vs-popup
      :active.sync="fileModal.active"
      title="เพิ่มข้อมูลไฟล์แนบ"
      class="custom-popup"
    >
      <div class="popup-content">
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="vs-input--label">แนบไฟล์เพิ่มเติม <small>(สามารถแนบไฟล์ได้ไม่จำกัด .jpg .jpeg .png .pdf .xlsx
              .xls .csv .doc .docx)</small></label>
            <vs-input type="text" class="w-full mt-2 mb-2" v-model="fileModal.description"/>
            <input type="file" @change="onFileChange" ref="inputFile"
                   accept=".jpg, .jpeg, .png, .pdf, .xlsx, .xls, .csv, .doc, .docx"/>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button color="success" :disabled="!fileModal.selectedFile || !fileModal.description"
                   @click="onPressedAcceptAddFile">บันทึก
        </vs-button>
        <vs-button color="danger" @click="fileModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers, mapGetters} from "vuex";
import {getUploadsUrl} from "@/utils/upload";
import vSelect from 'vue-select'
import {IContractStatus, ICreatedWith, IDebtCollectionFeeType, IExpenseType} from "@/constants/interface";
import {interestRateDefault} from "@/constants/config";

const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');
const {mapActions: mapCustomerActions} = createNamespacedHelpers('Customer');
const {mapActions: mapMasterActions} = createNamespacedHelpers('Master');

export default {
  name: 'ContractInfoTab',
  components: {
    Divider,
    vSelect,
  },
  data() {
    return {
      interestRateDetailModal: {
        active: false,
      },
      suretyModal: {
        active: false,
        surety: "",
        relationship: "",
      },
      fileModal: {
        active: false,
        selectedFile: null,
        description: ""
      },
      filteredSureties: [],
      totalMatched: 0,
      searchTimeout: null,
      maxOptions: 7,
      debounceTime: 500,
      reportServer: process.env.VUE_APP_REPORT_SERVER
    };
  },
  computed: {
    ...mapAccountingFields(['contractDetail', 'contractDetailRestructuringDetail', 'contractDetailInterestRateDetails', 'contractDetailSuretyDetails', 'contractDetailFiles', 'contractDetailBorrower']),
    ...mapGetters({
      suretyContractOptions: "Customer/suretyContractOptions",
      relationshipOptions: "Master/relationshipOptions",
    }),
    IExpenseType() {
      return IExpenseType
    },
    IContractStatus() {
      return IContractStatus
    },
    IDebtCollectionFeeType() {
      return IDebtCollectionFeeType
    },
    interestRateDefault() {
      return interestRateDefault
    },
    ICreatedWith() {
      return ICreatedWith
    },
    _contractDetail() {
      if (!this.contractDetail) return null;
      const {
        loan,
        borrower,
        contractDateLocalTh,
        contractNo,
        contractSeq,
        contractName,
        projectName,
        facultyCurriculumName,
        periodStartEnd,
        contractAmount,
        contractAmountText,
        createdWithName,
        contractStatus,
        restructuring,
        restructuringTypeName,
        campusName,
        contractStatusName,
        contractCloseDate
      } = this.contractDetail;
      const {
        interestRate,
        penaltyRate,
        paymentDescription,
        restructuringFeeRemain,
        restructuringPenaltyRemain,
        restructuringInterestRemain,
        restructuringPrincipleRemain,
        accruedFeeRemain,
        accruedPenaltyRemain,
        accruedInterestRemain,
        principleRemain,
        balanceRemain,
        outstandingAmountRemain,
        outstandingBalanceRemain,
        lastUpdateDateLocalTh,
        debtCollectionFeeType,
        debtCollectionFeeTypeName,
        contractFeeRemain,
        taxAmountRemain,
        processingFeeRemain,
        courtOrderExpenseRemain,
        loanTypeName
      } = loan
      const {
        idCardNumber,
        studentCode,
        fullName,
        mobile,
        phone,
        email,
        facultyCurriculumName: borrowerFacultyCurriculumName,
        degreeName,
        periodName,
        fullAddress
      } = borrower
      const {numberFormat} = this.$options.filters;
      return {
        contractDate: contractDateLocalTh,
        contractNo: `${contractNo} ${contractSeq}`,
        contractName,
        projectName,
        facultyCurriculumName,
        periodStartEnd,
        contractAmount: numberFormat(contractAmount),
        contractAmountText,
        interestRate: `${interestRate.toFixed(2)}%`,
        penaltyRate: `${penaltyRate.toFixed(2)}%`,
        debtCollectionFeeType,
        debtCollectionFeeTypeName,
        accruedFeeRemain: `${numberFormat(accruedFeeRemain)} ${restructuringFeeRemain > 0 ? `(${numberFormat(restructuringFeeRemain)})` : ''}`,
        accruedPenaltyRemain: `${numberFormat(accruedPenaltyRemain)} ${restructuringPenaltyRemain > 0 ? `(${numberFormat(restructuringPenaltyRemain)})` : ''}`,
        accruedInterestRemain: `${numberFormat(accruedInterestRemain)} ${restructuringInterestRemain > 0 ? `(${numberFormat(restructuringInterestRemain)})` : ''}`,
        principleRemain: `${numberFormat(principleRemain)} ${restructuringPrincipleRemain > 0 ? `(${numberFormat(restructuringPrincipleRemain)})` : ''}`,
        balanceRemain: `${numberFormat(balanceRemain)}`,
        outstandingAmountRemain: numberFormat(outstandingAmountRemain),
        outstandingBalanceRemain: numberFormat(outstandingBalanceRemain),
        lastUpdateDateLocalTh,
        paymentDescription,
        idCardNumber,
        studentCode,
        fullName,
        mobile,
        phone,
        email,
        borrowerFacultyCurriculumName,
        degreeName,
        periodName,
        fullAddress,
        createdWithName,
        contractStatus,
        contractFeeRemain: numberFormat(contractFeeRemain),
        taxAmountRemain: numberFormat(taxAmountRemain),
        processingFeeRemain: numberFormat(processingFeeRemain),
        courtOrderExpenseRemain: numberFormat(courtOrderExpenseRemain),
        restructuring,
        restructuringTypeName,
        campusName,
        contractStatusName,
        contractCloseDate,
        loanTypeName,
      }
    },
    restructuringDetail() {
      if (!this.contractDetailRestructuringDetail) return null;
      const {
        restructuringDateLocalTh,
        principleRemain,
        restructuringFeeRemain,
        restructuringPenaltyRemain,
        restructuringInterestRemain,
        remark,
        contracts
      } = this.contractDetailRestructuringDetail;
      const contract = contracts ? contracts[0] : null;
      const {
        id,
        contractNo,
        contractSeq,
        contractName,
        contractDateLocalTh,
        contractCloseDateLocalTh
      } = contract || {};
      return {
        restructuringDate: restructuringDateLocalTh,
        principleRemain,
        restructuringFeeRemain,
        restructuringPenaltyRemain,
        restructuringInterestRemain,
        remark,
        contract: {
          id,
          contractNo: `${contractNo} ${contractSeq}`,
          contractName,
          contractDate: contractDateLocalTh,
          contractCloseDate: contractCloseDateLocalTh
        }
      }
    },
    interestRateDetails() {
      if (!this.contractDetailInterestRateDetails) return [];
      return this.contractDetailInterestRateDetails.map((interestRateDetail) => {
        const {
          id,
          interestDateLocalTh,
          interestRate,
          penaltyRate,
          interestType,
          penaltyType,
          remark,
          debtCollectionFeeType,
          debtCollectionFeeTypeName
        } = interestRateDetail;
        return {
          id,
          interestDateLocalTh,
          interestRate,
          penaltyRate,
          interestType,
          penaltyType,
          debtCollectionFeeType,
          remark,
          debtCollectionFeeTypeName
        }
      })
    },
    suretyDetails() {
      if (!this.contractDetailSuretyDetails) return [];
      return this.contractDetailSuretyDetails.map((suretyDetail) => {
        const {id, seq, relationshipName, surety} = suretyDetail;
        const {idCardNumber, fullName, mobile, borrowerId} = surety;
        return {
          id,
          seq,
          relationshipName,
          idCardNumber,
          fullName,
          mobile,
          borrowerId,
        }
      })
    },
    files() {
      if (!this.contractDetailFiles) return [];
      return this.contractDetailFiles.map((file) => {
        const {id, seq, description, fileName, pathUrl, createdAtLocalTh, createByFullName} = file;
        return {
          id,
          seq,
          description,
          fileName,
          pathUrl,
          createdAtLocalTh,
          createByFullName,
        }
      })
    },
    borrower() {
      if (!this.contractDetailBorrower) return null;
      const {
        idCardNumber,
        studentCode,
        fullName,
        mobile,
        phone,
        email,
        facultyCurriculumName,
        degreeName,
        periodName,
        fullAddress
      } = this.contractDetailBorrower
      return {
        idCardNumber,
        studentCode,
        fullName,
        mobile,
        phone,
        email,
        facultyCurriculumName,
        degreeName,
        periodName,
        fullAddress
      }
    }
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'calculateContractDetail', 'createContractDetailSuretyDetail', 'deleteContractDetailSuretyDetail', 'uploadFile', 'createContractDetailFile', 'deleteContractDetailFile',
    ]),
    ...mapCustomerActions([
      "getSuretyContractOptions",
    ]),
    ...mapMasterActions([
      "getRelationshipOptions",
    ]),
    onSearchSurety(searchText) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.suretyContractOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalMatched = matched.length;
        this.filteredSureties = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    async onPressedCalculate() {
      const {id: contractId} = this.$route.params;
      const {calculateContractDetail} = this;
      const {dialog} = this.$vs;
      dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการคำนวนดอกเบี้ย',
        text: 'คุณต้องการคำนวนดอกเบี้ยถึงวันที่ปัจจุบันใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await calculateContractDetail({
            contractId,
            updateToNow: true,
            updateToDate: null
          })
        }
      })
    },
    async onPressedActiveInterestRateDetailModal() {
      this.interestRateDetailModal.active = true
    },
    async onPressedActiveSuretyModal() {
      const {
        suretyContractOptions,
        relationshipOptions,
        getSuretyContractOptions,
        getRelationshipOptions,
        $vs,
        suretyModal
      } = this;

      if (!suretyContractOptions.length || !relationshipOptions.length) {
        $vs.loading();
        await Promise.all([
          !suretyContractOptions.length && getSuretyContractOptions(),
          !relationshipOptions.length && getRelationshipOptions(),
        ]);
        $vs.loading.close();
      }

      await this.onSearchSurety('');
      suretyModal.active = true;
    },
    async onPressedRefreshSuretyOptions() {
      const {getSuretyContractOptions, $vs} = this;
      $vs.loading();
      await getSuretyContractOptions();
      $vs.loading.close();
    },
    async onPressedRefreshRelationshipOptions() {
      const {getRelationshipOptions, $vs} = this;
      $vs.loading();
      await getRelationshipOptions();
      $vs.loading.close();
    },
    async onPressedAcceptAddSurety() {
      const vm = this
      const contractId = this.$route.params.id;
      const suretyId = vm.suretyModal.surety.id;
      const relationshipId = vm.suretyModal.relationship;
      if (!suretyId) {
        vm.$vs.notify({
          title: 'กรุณาเลือกผู้ค้ำประกัน',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
        return;
      } else if (!relationshipId) {
        vm.$vs.notify({
          title: 'กรุณาเลือกความสัมพันธ์',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
        return;
      }
      const {createContractDetailSuretyDetail} = vm;
      await createContractDetailSuretyDetail({
        contractId,
        form: {
          surety: {id: suretyId},
          relationship: {id: relationshipId},
        }
      })
      vm.suretyModal.active = false;
      vm.suretyModal.surety = null;
      vm.suretyModal.relationship = "";
    },
    async onPressedDelSurety(id) {
      const vm = this
      const {deleteContractDetailSuretyDetail} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailSuretyDetail({
            id,
            vm
          })
        }
      })
    },
    async onPressedShowInterestRateDetailRemark(remark) {
      alert(remark)
    },
    async onPressedActiveFileModal() {
      this.fileModal.active = true
    },
    async onPressedAcceptAddFile() {
      const vm = this
      const formData = new FormData();
      const {createContractDetailFile} = vm;
      const contractId = this.$route.params.id;
      formData.append("file", vm.fileModal.selectedFile);  // appending file
      const result = await vm.uploadFile({
        id: contractId,
        form: {
          formData: formData
        },
        vm
      });
      await createContractDetailFile({
        contractId,
        form: {
          description: vm.fileModal.description,
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        }
      });
      vm.fileModal.active = false
      vm.fileModal.description = ""
      vm.fileModal.selectedFile = null
      vm.$refs.inputFile.value = null
    },
    async onFileChange(e) {
      this.fileModal.selectedFile = e.target.files[0]; // accessing file;
    },
    async onPressedDownload(file) {
      const url = getUploadsUrl(file.fileName)
      window.open(url, '_blank');
    },
    async onPressedDelFile(id) {
      const vm = this
      const {deleteContractDetailFile} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailFile({
            id,
            vm
          })
        }
      })
    },
    async onPressedGoToContract(id) {
      const vm = this
      vm.$router.push({name: 'accounting-contract-detail', params: {id: id}}).then(() => {
        vm.$router.go(0);
      });
    }
  },
}
</script>

<style scoped>
.bordered-group-dotted {
  border: 1px dotted #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group {
  border: 1px solid #ddd; /* Custom border */
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 300px;
}

.col-actions {
  width: 150px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 20px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}

.center-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
